import { Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingButtons from "@/components/layout/FloatingButtons";
import ScrollTop from "@/components/layout/ScrollTop";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ScrollTop />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
